import { useQuery } from '@tanstack/react-query';
import type { SuggestedCandidate } from '../types/SuggestedCandidate';
import type { AgentApiJobPostEndpointsShow } from '@/types/serializers';

interface SuggestedCandidatesResponse {
  suggested_candidates: SuggestedCandidate[];
  total_count: number;
}

export default function useFetchSuggestedCandidates(jobPostId: number) {
  return useQuery({
    queryKey: ['suggestedCandidates', jobPostId],
    queryFn: async () => {
      const response = await fetch(`/agent/api/job_post_endpoints/${jobPostId}.json`);

      if (!response.ok) {
        throw new Error('Failed to fetch suggested candidates');
      }

      const data: AgentApiJobPostEndpointsShow = await response.json();

      // APIレスポンスをSuggestedCandidate形式に変換
      const suggestedCandidates: SuggestedCandidate[] = data.job_post_endpoints
        .filter((endpoint) => endpoint.candidate_profile !== null) // candidate_profileがnullのレコードは除外
        .map((endpoint) => ({
          // APIレスポンスをそのまま使用し、必要なフィールドのみ追加
          ...endpoint,
          candidate_profile: endpoint.candidate_profile!, // filterで除外済みなので!で型アサーション
          candidate_profile_id: endpoint.candidate_profile!.id,
          provided_job_post_id: jobPostId,
        }));

      return {
        suggested_candidates: suggestedCandidates,
        total_count: suggestedCandidates.length,
      } as SuggestedCandidatesResponse;
    },
    enabled: !!jobPostId,
  });
}
